import { Pipe, PipeTransform } from '@angular/core'
import { buildDate, buildFullDate } from '../../utils/date'


@Pipe({
  name: 'dateFormat',
  pure: true
})
export class DateFormatPipe implements PipeTransform {

  public transform(value: string | Date, showTime = false, showSeconds = false): string {
    const date = new Date(value)
    if (date.getTime() === 0) return 'N/A'
    return showTime ? buildFullDate(value, showSeconds) : buildDate(value)
  }

}
